import { createSelector } from 'reselect'

const modalVisible = state => state.app.modal.visible

export const modalVisibleSelector = createSelector(
	modalVisible,
	modalVisible => modalVisible
)

const modalData = state => state.app.modal.data

export const modalDataSelector = createSelector(
	modalData,
	modalData => modalData
)
